export const jwt = () => {
  const token = localStorage.getItem("token");
  return token ?? null;
};
